import { useEffect, useState } from 'react';
import { iconePara, temArtePropria } from '../assets/items';
import { deveTingirIcone, iconeTingido } from '../look/iconeMaterial';
import { useIconeTingido } from './useIconeTingido';

interface ItemIconProps {
  /** Id do item — `black-pearl`, `plate-helm`, `bow@oak`. O material vem no id e tinge o ícone. */
  id: string;
  /** Nome legível. Vira o `alt`, então precisa dizer o que a imagem mostra. */
  label?: string;
  size?: number;
  /** Quantidade, para empilháveis. Não desenha nada quando é 1. */
  quantity?: number;
  className?: string;
  /** Ícones do mercado / mochila visíveis — não atrasar com lazy. */
  eager?: boolean;
}

/**
 * Ícone de um item, com o espaço reservado quando a arte ainda não existe.
 *
 * Nunca renderiza imagem quebrada: `iconePara` sempre devolve uma URL.
 */
export function ItemIcon({ id, label, size = 44, quantity, className, eager = false }: ItemIconProps) {
  const semArte = !temArtePropria(id);
  const classes = ['itemicon', semArte && 'itemicon--placeholder', className]
    .filter(Boolean).join(' ');
  const original = iconePara(id, quantity);
  const [src, setSrc] = useState(original);

  useEffect(() => {
    if (!deveTingirIcone(id)) {
      setSrc(original);
      return;
    }
    let live = true;
    void iconeTingido(id, quantity).then(url => {
      if (live) setSrc(url);
    });
    return () => { live = false; };
  }, [id, quantity, original]);

  return (
    <span className={classes} style={{ width: size, height: size }}>
      <img
        src={src}
        // Sem label, o ícone é decorativo e o nome vem do texto ao lado.
        alt={label ?? ''}
        width={size}
        height={size}
        draggable={false}
        loading={eager ? 'eager' : 'lazy'}
      />
      {quantity !== undefined && quantity > 1 && (
        <span className="itemicon__qty">{quantity > 999 ? '999+' : quantity}</span>
      )}
    </span>
  );
}

/** `<img>` cru com a cor do material: para slots que já desenham a moldura (barra, combate). */
/** `qty` escolhe a arte da pilha (lingote e minério têm 1, 5 e 25+). */
export function ImgDoItem({ id, size, alt = '', qty }: { id: string; size: number; alt?: string; qty?: number }) {
  const src = useIconeTingido(id, qty);
  return <img src={src} alt={alt} width={size} height={size} draggable={false} />;
}
